import { render, staticRenderFns } from "./IntroducerBankAccountSortCode.vue?vue&type=template&id=1e560c2a"
import script from "./IntroducerBankAccountSortCode.vue?vue&type=script&lang=js"
export * from "./IntroducerBankAccountSortCode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports